import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Container } from './ui';
import { getRelatedPages } from '../lib/related-pages';
import type { Lang } from '../lib/routes';
import styles from './RelatedPages.module.css';

interface RelatedPagesProps {
  /** Canonical FR path of the current page (e.g. '/solutions/business-model'). */
  currentFrPath: string;
}

export function RelatedPages({ currentFrPath }: RelatedPagesProps) {
  const { i18n } = useTranslation();
  const lang: Lang = i18n.language === 'en' ? 'en' : 'fr';
  const items = getRelatedPages(currentFrPath, lang);

  if (items.length === 0) return null;

  const heading = lang === 'fr' ? 'Explorer aussi' : 'Explore also';

  return (
    <section className={styles.section} aria-label={heading}>
      <Container>
        <h2 className={styles.heading}>{heading}</h2>
        <div className={styles.grid}>
          {items.map((item) => (
            <Link key={item.href} to={item.href} className={styles.card}>
              <div className={styles.cardTitle}>
                <span>{item.title}</span>
                <span className={styles.arrow} aria-hidden="true">
                  →
                </span>
              </div>
              <p className={styles.cardTeaser}>{item.teaser}</p>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}
